import React from 'react';
import { useParams } from 'react-router-dom';
import CryptoPaymentForm from './CryptoPaymentForm';

const PaymentPage = () => {
  const { planType, billingPeriod } = useParams();

  return (
    <div>
      <CryptoPaymentForm planType={planType} billingPeriod={billingPeriod} />
    </div>
  );
};

export default PaymentPage;
